import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, TouchableOpacity, Image } from 'react-native';
import { Checkbox } from 'react-native-paper';
import { LinearGradient } from "expo-linear-gradient";

import HeaderDefault from '../../components/HeaderDefault';

import styles from "./styles";

const BuyExchange = ({ navigation, route }) => {
    const [checked, setChecked] = useState(false);
    const [qtd, setQtd] = useState();
    const [token, setToken] = useState(null);
    const [valueCoin, setValueCoin] = useState("0");

    useEffect(() => {
        setToken(route.params.token);
        setQtd(JSON.stringify(route.params.qtd));
    }, []);

    return (
        <>
            <HeaderDefault title={"EXCHANGE"} />

            <View style={styles.content}>
                <View style={styles.token_header_container}>
                    {token && <Image source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${token.path}` }} style={styles.token_header_image} />}
                    <Text style={styles.token_header_title}>{token ? token.name_token : "GPX"}</Text>
                </View>
                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>Definir quantidade:</Text>
                    <TextInput style={styles.textInputAmount} value={qtd} onChangeText={(e) => setQtd(e.toString())} keyboardType="numeric" />
                </View>

                <View style={styles.contentAmount}>
                    <Text style={styles.titlePage}>Definir preço de compra:</Text>
                    <TextInput style={styles.textInputAmount} value={valueCoin} onChangeText={(e) => setValueCoin(e.toString())} keyboardType="numeric" />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}> Último preço:</Text>
                    <Text style={styles.price}>000.000,00GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de venda:
                    </Text>
                    <Text style={styles.price}>{token ? token.single_value : "000.000,00"}GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.descriptionPrice}>
                        Preço de mercado:
                    </Text>
                    <Text style={styles.price}>000.000,00GPX</Text>
                </View>
            </View>

            <View style={styles.contentCheckbox}>
                <Checkbox
                    status={checked ? 'checked' : 'indeterminate'}
                    onPress={() => {
                        setChecked(!checked);

                    }}
                />
                <Text>Comprar a preço de mercado</Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={() => navigation.navigate('ConfirmPassword', { qtd: qtd, valueCoin: valueCoin, market: checked, purchase: true })}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>CONTINUAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default BuyExchange;